import React, { useEffect, useState } from 'react';
import UnityGameSandbox from './UnityGameSandbox';
import UnityGameSandboxMobile from './UnityGameSandboxMobile';

// Mobile detection utility
const isMobileDevice = (): boolean => {
  if (typeof window === 'undefined') return false;
  
  // Only check user agent for mobile phones (exclude tablets like iPad)
  // This is very conservative - only triggers for actual mobile phone user agents
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
  const mobilePhoneRegex = /android.*mobile|iphone|ipod|blackberry|iemobile|opera mini/i;
  
  // Check if it's a mobile phone user agent AND has a small screen
  const isMobileUserAgent = mobilePhoneRegex.test(userAgent.toLowerCase());
  const hasSmallScreen = window.innerWidth <= 768;
  
  // Only return true if BOTH conditions are met
  return isMobileUserAgent && hasSmallScreen;
};

const Sandbox: React.FC = () => {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    // Detect mobile on mount
    setIsMobile(isMobileDevice());
    
    // Re-check on resize
    const handleResize = () => {
      setIsMobile(isMobileDevice());
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Render mobile sandbox for mobile devices
  if (isMobile) {
    return <UnityGameSandboxMobile />;
  }

  // Render desktop sandbox for desktop devices
  return <UnityGameSandbox />;
};

export default Sandbox;

